export enum ELeftSideBarLoadings {
  setSportsLoading = 'left_sidebar_sports_loading',
  setCasinoLoading = 'left_sidebar_casino_categories_loaded'
}
